var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleModuleDashboard',{attrs:{"module-id":_vm.Modules.PHP,"profile-id":_vm.Profiles.PERSONAL,"include-php-custom":"","actions":_vm.actions,"widget-filter":_vm.filterWidgets}})}
var staticRenderFns = []

export { render, staticRenderFns }